import { useCallback } from 'react';
import { useUpdateParentIdMutation } from './useGroupOperationsMutation';
import { showToast, TOAST_SUCCESS, FIVE_SECONDS } from 'lib/utils';

export const useRemoveFromGroup = (locationId: string) => {
  const updateParentIdMutation = useUpdateParentIdMutation(locationId);

  const removeFromGroup = useCallback(
    async (requestId: string) => {
      if (!locationId) return;
      await updateParentIdMutation.mutateAsync({ requestId, parentId: null });
      showToast('1 item removed from group', TOAST_SUCCESS, FIVE_SECONDS);
    },
    [updateParentIdMutation, locationId]
  );

  return { removeFromGroup };
};
